module.exports = __webpack_public_path__ + "img/鹿城区教育局.ab87804a.png";